import { useEffect, useState } from 'react';
import { ElevatedButton } from '@producer/ui-kit';

import styles from './desktop-warning.module.scss';
const STORAGE_KEY = 'desktop-warning';

export const DesktopWarning = () => {
  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const hasDismissed = window.localStorage.getItem(STORAGE_KEY);

    if (!hasDismissed) {
      setShouldDisplay(true);
    }
  }, []);

  const handleDismiss = () => {
    setShouldDisplay(false);
    window.localStorage.setItem(STORAGE_KEY, 'dismissed');
  };

  if (!shouldDisplay) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2.49378L17.53 15.5038H2.47L10 2.49378ZM0.739999 14.5038C-0.0300008 15.8338 0.929999 17.5038 2.47 17.5038H17.53C19.07 17.5038 20.03 15.8338 19.26 14.5038L11.73 1.49378C10.96 0.163777 9.04 0.163777 8.27 1.49378L0.739999 14.5038ZM9 7.50378V9.50378C9 10.0538 9.45 10.5038 10 10.5038C10.55 10.5038 11 10.0538 11 9.50378V7.50378C11 6.95378 10.55 6.50378 10 6.50378C9.45 6.50378 9 6.95378 9 7.50378ZM9 12.5038H11V14.5038H9V12.5038Z"
            fill="#F8A72D"
          />
        </svg>

        <p>For now, some functions of PRODUCER are only accessible on the desktop version.</p>
      </div>

      <div className={styles['actions']}>
        <ElevatedButton text="Okay, got it" onClick={handleDismiss} />
      </div>
    </div>
  );
};
